import { IMap } from 'helpers/types';
import { X_PLANERA_ORGANIZATION_ID, DO_NOT_SEND_HEADER, X_PLANERA_WORKSPACE_ID } from 'state_management/threadedConstants';

import { sendRequest } from '../core';
import { User } from './classes';
import { IUserRequest, UpdateUserRequest } from './requests';
import { IUserResponse } from './responses';

export async function getUserByID(id: string) {
  return sendRequest<IUserResponse>('GET', `/api/v1/user/${id}`, undefined, {
    [X_PLANERA_ORGANIZATION_ID]: DO_NOT_SEND_HEADER,
    [X_PLANERA_WORKSPACE_ID]: DO_NOT_SEND_HEADER
  }).then((resp) => User.fromJson(resp));
}

export async function createUser(user: User) {
  return sendRequest<IUserResponse, IUserRequest>('POST', `/api/v1/user`, {
    userId: user.authUserID,
    email: user.email,
    name: user.name,
    orgId: user.organizationID,
    roles: user.roleIDs.map((id) => ({ id })),
    roleAlias: user.roleAlias,
    settings: user.settings
  }).then((resp) => User.fromJson(resp));
}

export async function updateUser(id: string, user: User) {
  return sendRequest<IUserResponse, IUserRequest>('PUT', `/api/v1/user/${id}`, {
    userId: user.authUserID,
    email: user.email,
    name: user.name,
    orgId: user.organizationID,
    roles: user.roleIDs.map((id) => ({ id })),
    roleAlias: user.roleAlias,
    settings: user.settings
  }).then((resp) => User.fromJson(resp));
}

export async function updateUserPartial(id: string, user: UpdateUserRequest) {
  return sendRequest<any, UpdateUserRequest>('PUT', `/api/v1/user/${id}`, user);
}

interface SetPasswordRequest {
  password: string;
}

export async function updateUserPassword(id: string, newPassword: string) {
  return sendRequest<void, SetPasswordRequest>('POST', `/api/v1/user/${id}/set-password`, { password: newPassword });
}

export async function updateUserSettings(id: string, settings: IMap) {
  if (!id) {
    logger.warn('User settings call missing user id', { extra: { settings } });
    return;
  }
  return sendRequest<void>('PATCH', `/api/v1/user/${id}/settings`, { settings: settings });
}

export async function deleteUser(id: string) {
  return sendRequest<void>('DELETE', `api/v1/user/${id}`);
}
